<template>
  <b-container class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>
          Intervalové dáta
          <small>({{ count | formatNumber }})</small>
        </h2>
      </div>
      <div class="d-flex flex-grow-1">
        <input-filter
          ref="filter"
          :filters="table.filter"
          :options="filterOptions"
          @onReset="resetFilter"
          @onSearch="search"
        >
          <template #filter>
            <b-row>
              <b-col md="4">
                <b-form-group
                  label="Dátum:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="date"
                >
                  <b-input-group class="input-group-labeled">
                    <date-picker
                      v-model="table.filter.date"
                      class="flex-grow-1 daterange-sm"
                      opens="right"
                      @update="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.date = { ge: null, lt: null }
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Distrib. územie:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="distributionArea"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="table.filter.distributionArea"
                      :options="[
                        { id: 2, name: 'VSD' },
                        { id: 3, name: 'SSD' },
                        { id: 4, name: 'ZSDIS' },
                        { id: 1, name: 'SPP-distribúcia, a.s.' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.distributionArea = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </input-filter>
      </div>
    </div>
    <div ref="scroll" v-bar class="bar-out">
      <div>
        <server-table
          ref="table"
          :api-request="apiRequest"
          :columns="table.columns"
          :searchable="false"
          :sort-by.sync="table.sortBy"
          :sort-desc="true"
          bordered
          hover
          striped
          @refreshed="onLoaded"
        >
          <template #cell(energetics)="data">
            <template v-if="data.item._type.const === 'POWER'">
              <div class="text-nowrap">
                <b-badge class="bg-power align-middle">
                  <icon class="icon-fw" name="plug" scale="0.75" />
                </b-badge>
                {{ data.item.powerNumber }}
              </div>
            </template>
            <template v-if="data.item._type.const === 'GAS'">
              <div class="text-nowrap">
                <b-badge class="bg-gas align-middle">
                  <icon class="icon-fw" name="fire" scale="0.75" />
                </b-badge>
                {{ data.item.gasNumber }}
              </div>
            </template>
            <div class="fs-sm text-muted">
              {{ data.item.localityName }}
            </div>
          </template>
        </server-table>
      </div>
    </div>
  </b-container>
</template>
<script>
import InputFilter from '@/components/InputFilter'
import Selectbox from '@/components/inputs/Selectbox'
import DatePicker from '@/components/inputs/DatePicker'
import ServerTable from '@/components/ServerTable'
import moment from 'moment'

export default {
  components: {
    InputFilter,
    Selectbox,
    DatePicker,
    ServerTable,
  },
  data() {
    return {
      loading: false,
      table: {
        columns: [
          {
            key: 'energetics',
            label: 'Odberné miesto',
            sortable: true,
            sortableKey: 'powerNumber, gasNumber',
            searchable: true,
          },
          {
            key: 'distributionArea',
            label: 'Distribučné územie',
            formatter: (value, key, item) =>
              item._distributionArea ? item._distributionArea.name : '-',
            sortable: true,
            sortableKey: 'distributionAreaID',
            searchable: true,
          },
          {
            key: 'date',
            label: 'Dátumy',
            formatter: (value, key, item) =>
              item.missingDates
                .map((i) => this.$options.filters.formatDate(i))
                .join(', '),
          },
        ],
        filter: {
          date: {
            ge: moment().startOf('year').format('YYYY-MM-DD'),
            lt: moment().format('YYYY-MM-DD'),
          },
          distributionArea: null,
        },
      },
      filterOptions: {
        placeholder: 'Filtrovanie a hľadanie...',
      },
      count: null,
    }
  },
  computed: {},
  methods: {
    apiRequest(params) {
      return this.$api.get('energy_data/get_not_downloaded', {
        params: { filter: this.table.filter, ...params },
      })
    },
    onLoaded() {
      this.count = this.$refs.table.totalRows
    },
    search() {
      this.$refs.table.searchVal = this.$refs.filter.value
      this.$nextTick(() => {
        this.$refs.table.search()
      })
    },
    resetFilter() {
      this.$refs.table.reset()
    },
  },
}
</script>
